// extracted by mini-css-extract-plugin
export var downArrow = "_7y-0";
export var infoTooltipIcon = "_7y-3";
export var label = "_7y-1";
export var optionCard = "_7y-4";
export var upArrow = "_7y-2";